function capitalizeFirstLetter(str) {
  if (!str) return str;

  return `${str.charAt(0).toUpperCase()}${str.substring(1).toLowerCase()}`;
}

// Service categories such as "Security & Identity" travel through the URL either properly
// encoded ("Security%20%26%20Identity") or with the ampersand spelled out ("Security and
// Identity"). Normalise both back to the canonical name the API expects, and collapse the
// stray whitespace an un-encoded "&" leaves behind.
function normalizeCategoryParam(value) {
  if (!value) return value;

  return value
    .replace(/\s+and\s+/gi, ' & ')
    .replace(/\s+/g, ' ')
    .trim();
}

export { capitalizeFirstLetter, normalizeCategoryParam };
